import React, { useEffect, useState } from 'react';
import { GFM_SUPPLIERS, matchSupplier } from '../constants/gfm';

const OTHER = '__other__';

function capWords(s = '') {
  return s.replace(/(^\w|\s\w)/g, c => c.toUpperCase());
}

/**
 * Supplier dropdown for GFM orders. Picking "Other" shows a text box so an
 * unlisted supplier can still be entered. Orders saved with an unlisted
 * supplier open in "Other" mode with the name filled in.
 */
export default function SupplierSelect({ id, value, onChange }) {
  const listed = matchSupplier(value);
  const [other, setOther] = useState(!!String(value || '').trim() && !listed);

  // Follow the value if the parent changes it to an unlisted supplier
  useEffect(() => {
    if (String(value || '').trim() && !listed) setOther(true);
  }, [value, listed]);

  function onSelect(e) {
    const v = e.target.value;
    if (v === OTHER) {
      setOther(true);
      onChange('');
    } else {
      setOther(false);
      onChange(v);
    }
  }

  return (
    <>
      <select
        id={id}
        className="input"
        value={other ? OTHER : listed}
        onChange={onSelect}
        required
      >
        <option value="" disabled>Select a supplier</option>
        {GFM_SUPPLIERS.map(s => <option key={s} value={s}>{s}</option>)}
        <option value={OTHER}>Other</option>
      </select>
      {other && (
        <input
          className="input"
          value={value}
          onChange={e => onChange(capWords(e.target.value))}
          placeholder="Supplier name"
          aria-label="Supplier name"
          autoFocus={!value}
        />
      )}
    </>
  );
}
